import { render, staticRenderFns } from "./retailhalfprice.vue?vue&type=template&id=aa85634a&scoped=true"
import script from "./retailhalfprice.vue?vue&type=script&lang=js"
export * from "./retailhalfprice.vue?vue&type=script&lang=js"
import style0 from "./retailhalfprice.vue?vue&type=style&index=0&id=aa85634a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa85634a",
  null
  
)

export default component.exports